// 计费单

import { HttpGetInventoryList, HttpGetInventoryListExport,HttpGetProduct } from '@/service/inventory';
import TableList from "@components/templates/tablelist";
import mixin from "../mixin";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                'search[EQ_organizationId]': this.isAdmin() ? '' : global.SYSID,
                'state': this.isAdmin() ? '2' : '0',
                'search[IN_warehouseType]':'2'
            },
            products:[],
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpGetInventoryList,
        interceptResponse(params){
            if(params.content.length>0){
                let productIds = [];
                params.content.forEach(item => {
                    productIds.push(item.productId);
                  });
                HttpGetProduct({
                    contextId: global.SYSID,
                    productIds:productIds
                  })
                    .then(res => {
                        this.products = res.data;
                    })
                    .catch(err => {
                      this.$VMessage.error(err.message);
                    });
            }
            
        },
        interceptRequest(params) {
            const search = params.search
            if (this.$route.query.erpsku) {
                search.RCN_sku = this.$route.query.erpsku
                delete params.search.BT_updatedAt;
                // console.log(params)
                return params
            } else {
                return params
            }
        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'export':
                    this.handleWebfs(HttpGetInventoryListExport, this.formData, 'download')
                    break;
            }
        },
        isAdmin() {
            return this.$route.name === 'inventorySerChannel';
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getBillcusorgList','getSelfmanageorgList', 'getCusproductList', 'getManageAccountList', 'getOrgAccountList']),
        // ...mapGetters('common', ['getInventoryType', 'getProductType']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    show: this.handleAuth('fbb.channelinventory.export'),
                    operate: "export",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('bi.work.task_org_id', { defaultValue: "组织" }),
                    key: 'EQ_organizationId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    hidden: !this.isAdmin(),
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('bi.work.task_account_id', { defaultValue: "渠道" }),
                    key: this.isAdmin() ? 'IN_orgWarehouseCode' : 'IN_orgWarehouseCode',
                    show: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getManageAccountList: this.getOrgAccountList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'IN_groupCode',
                    more: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getCusproductList : this.getProductList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: "SKU",
                    key: 'RCN_sku',
                    show: true,
                    default: this.$route.query.erpsku,
                    tag: 'vInput',
                },
                {
                    label: this.$t('erp.setting.goods_type', { defaultValue: "产品类型" }),
                    key: 'EQ_productType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getProductType,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.inbound.inventory_type', { defaultValue: "库存类型" }),
                    key: 'EQ_inventoryType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getInventoryType,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('global.common.updatedAt', { defaultValue: "更新时间" }),
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    show: true,
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },

            ]
        },
        columns() {
            return [
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'organizationId',
                    width: this.isAdmin() ? 100 : 0,
                    render: (h, { row }) => {
                        let orgName = this.getSelfmanageorgList.filter(item => {
                            return item.value === row.organizationId
                        })[0] || {}
                        return orgName.label
                    }
                },
                {
                    title: this.$t('bi.work.task_account_id', { defaultValue: '渠道' }),
                    maxWidth: 200,
                    render: (h, { row }) => {
                        return <div>{row.orgWarehouseName}</div>
                    }
                },
                {
                    title: this.$t('global.common.project', { defaultValue: '项目' }),
                    key: 'lineName',
                },
                {
                    title: 'SKU',
                    key: 'sku',
                },
                {
                    title: this.$t('erp.setting.goods_type', { defaultValue: '产品类型' }),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let productType = row.productType
                        const { label } = this.getProductType.find(function (item) {
                            return item.value == productType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let inventoryType = row.inventoryType
                        const { label } = this.getInventoryType.find(function (item) {
                            return item.value == inventoryType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.inventory.FBA_sale', { defaultValue: 'FBA可售' }),
                    key: 'inventoryAvailable',
                    sortable: true
                },
                {
                    title: this.$t('erp.product.reserved', { defaultValue: '预留' }),
                    key: 'inventoryReserved',
                    sortable: true,
                    width:110,
                    render:(h,{row})=>{
                        return <div>
                            <div>{this.$t('fbb.inventory.total_reservation', { defaultValue: '总预留：' })}{row.inventoryReserved}</div>
                            <div>{this.$t('fbb.inventory.warehouse_adjustment_for', { defaultValue: '待调仓预留：' })}{row.inventoryPreRelocation}</div>
                            <div>{this.$t('fbb.inventory.warehouse_adjustment_in', { defaultValue: '调仓中预留：' })}{row.inventoryRelocationing}</div>
                            <div>{this.$t('fbb.inventory.shipment_for', { defaultValue: '待发货预留：' })}{row.inventoryPreShipped}</div>
                        </div>
                    }
                },
                {
                    title: 'InBound',
                    key: 'inventoryFbaTransport',
                    sortable: true,
                    width:110,
                    render:(h,{row})=>{
                        return <div>
                            <div>{this.$t('fbb.inventory.planned_storage', { defaultValue: '计划入库' })}:{row.inventoryFbaInboundPlan}</div>
                            <div>{this.$t('tms.ship.in_transit', { defaultValue: '在途' })}:{row.inventoryFbaTransport}</div>
                            <div>{this.$t('fbb.inventory.in_storage', { defaultValue: '入库中' })}:{row.inventoryLoss}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.inventory.under_investigation', { defaultValue: '调查中' }),
                    key: 'inventoryChecking',
                    width:110,
                },
                // {
                //     title: this.$t('erp.product.current', { defaultValue: '总库存' }),
                //     key: 'inventoryCurrent',
                //     sortable: true
                // },
                {
                    title: this.$t('fbb.inventory.product_value', { defaultValue: '产品价值' }),
                    key: 'fobCost',

                },
                {
                    title: `${this.$t('fbb.accountmanage.material_size_length', { defaultValue: '长' })}*${this.$t('fbb.accountmanage.material_size_width', { defaultValue: '宽' })}*${this.$t('fbb.accountmanage.material_size_height', { defaultValue: '高' })}(cm)`,
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var Length = product.length;
                            var Width =  product.width;
                            var Height =  product.height;
                            return <div>{Length}*{Width}*{Height}</div>
                          }
                       
                    }
                },
                {
                    title: this.$t('global.common.weight(g)', { defaultValue: '重量(g)' }),
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var weight2 = product.weight
                            return <div>{weight2}</div>
                          }
                        
                        
                    }
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    width: 150,
                    render: (h, { row }) => {
                        return <div>{row.updatedAt || '--'}</div>
                    }
                },
            ];
        },
    },
};




